<mat-dialog-content>
  <h3 style="color:#a20000;" translate>Duplicate Email Address</h3>
  <div style="padding-top:15px;" translate>A record already exists with this email address.</div>
  <div style="padding-top:15px;" translate>If your students are already registered at the district or have attended the district in the past, this option cannot be used.</div>
</mat-dialog-content>
<mat-dialog-actions style="position: sticky">
  <div class="footerRight">
    <tyl-button image="Cancel.png" label="Close" (clickEvent)="modalInstanceCloseClick()"></tyl-button>
  </div>
</mat-dialog-actions>